// Sticky banner shown only in demo mode. Lets a prospect switch between role
// perspectives and exit the demo. Rendered at the top of the authenticated app.

import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'
import { DEMO_ROLES, disableDemo, getDemoRole, setDemoRole, isDemoMode } from './demoMode'

export default function DemoBanner() {
  const { user } = useAuth()
  const [open, setOpen] = useState(false)

  if (!isDemoMode()) {
    return null
  }

  const currentRole = getDemoRole()
  const current = DEMO_ROLES.find(r => r.role === currentRole) || DEMO_ROLES[0]

  const exit = () => {
    disableDemo()
    window.location.assign('/login')
  }

  return (
    <div className="sticky top-0 z-30 bg-gradient-to-r from-emerald-600 to-green-500 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-3 py-2 flex-wrap">
          <div className="flex items-center gap-2 text-sm font-medium">
            <span className="inline-flex items-center rounded-full bg-white/20 px-2 py-0.5 text-xs font-bold uppercase tracking-wide">
              Live Demo
            </span>
            <span className="hidden sm:inline">
              You’re exploring eCombine with sample data as a <strong>{current.label}</strong>.
            </span>
            <span className="sm:hidden">
              Viewing as <strong>{current.label}</strong>
            </span>
          </div>

          <div className="flex items-center gap-2">
            <div className="relative">
              <button
                onClick={() => setOpen(o => !o)}
                className="inline-flex items-center gap-1.5 rounded-md bg-white/15 hover:bg-white/25 px-3 py-1.5 text-sm font-semibold transition-colors"
              >
                Switch role
                <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                  <path
                    fillRule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.17l3.71-3.94a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
              {open && (
                <div className="absolute right-0 mt-1 w-72 rounded-lg bg-white text-gray-800 shadow-xl ring-1 ring-black/5 overflow-hidden">
                  {DEMO_ROLES.map(r => (
                    <button
                      key={r.role}
                      onClick={() => setDemoRole(r.role)}
                      className={`flex w-full flex-col items-start px-4 py-2.5 text-left hover:bg-emerald-50 transition-colors ${
                        r.role === currentRole ? 'bg-emerald-50' : ''
                      }`}
                    >
                      <span className="text-sm font-semibold text-gray-900">
                        {r.label}
                        {r.role === currentRole && (
                          <span className="ml-2 text-xs text-emerald-600">● current</span>
                        )}
                      </span>
                      <span className="text-xs text-gray-500">{r.blurb}</span>
                    </button>
                  ))}
                </div>
              )}
            </div>
            <button
              onClick={exit}
              className="rounded-md bg-white/15 hover:bg-white/25 px-3 py-1.5 text-sm font-semibold transition-colors"
            >
              Exit demo
            </button>
          </div>
        </div>
      </div>
      {user && <span className="sr-only">Signed in as {user.email}</span>}
    </div>
  )
}
